<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content>
  <p>{{ data.content | translate }}

    <ng-container *ngIf="data.orderIdentifier">{{data.orderIdentifier}}</ng-container>
  </p>

</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onDismiss()">{{ "global.dialog.ok" | translate }}</button>
</div>